import { styled } from '@mui/material/styles';
import { AppBar, Toolbar } from '@mui/material';
import { HEADER_HEIGHT, NAV_WIDTH } from '../../constants';

export const StyledRoot = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  background: 'transparent',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_HEIGHT,
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 5),
  },
  [theme.breakpoints.up('xs')]: {
    minHeight: HEADER_HEIGHT,
  },
}));
